


// Creates the match bracket order based on the size and number of regions
export function createMatchBracketOrder(numPlayers: number, regions: number, regionRounds: number) {
        
    // Variables for initital ranking
    const ranks = Array.from({ length: numPlayers }, (_, i) => i + 1);
    const matchOrder = [];

    let top = 0; // Start from the top rank (1st)
    let bottom = Math.max(Math.pow(2, regionRounds)*regions-1, numPlayers - 1); // Start from the bottom rank (lowest)

    // Loop until all players are paired matching up the top and bottom ranks
    while (top < bottom) {
        // Create a match object for the top and bottom ranks
        matchOrder.push({ player1: ranks[top] || 'BYE', player2: ranks[bottom] || 'BYE' });
        top++;
        bottom--;
    }

    // Variables for final ordering
    const matchCount = regions*Math.pow(2, regionRounds)/2;  // Total matches in the first round
    //const matchRounds = Math.log2(matchCount) || 1;  // Total rounds in each bracket
    const matchIterations = matchCount/(Math.pow(2, regionRounds)*Math.log2(regions) || 2);  // Total iterations to complete the bracket
    const subRegionIterations = matchCount/regions/2;  // Total iterations to complete the sub-regions

    let bracketRowsIn = 0;  // Bracket rows from the edge, starts at the outside
    let pairCounter = 0;  // Counter for the number of pairs
    let matchCounter = 1;  // Counter for the match number going up
    let matchCounterDown = matchCount;  // Counter for the match number going down
    
    const reorderedMatches = [];

    // Loop until all matches are ordered
    while (bracketRowsIn < matchIterations) {

        // Loops through the number of sub-regions needed for correct ordering within the bracket regions
        for (let j = 0; j < subRegionIterations; j++) {
            
            // Loops through the number of regions in the bracket
            // For the top half of the bracket region
            for (let i = 0; i < regions; i++) {

                // Creates the object to push to the reordered matches array
                const pushItem = {
                    ...matchOrder[pairCounter], // picks next match in the original ranked order
                    matchNumber: matchCounter, // match number in the bracket
                    region: (bracketRowsIn % 2 === 0 ? i : regions - 1 - i), // region number, alternating to stop all odds in one region
                    subRegion:
                      (j % 2 === 0 || regionRounds < 4 ?
                        j : 
                        subRegionIterations - 1 - j
                      ),
                    // Sub-region number, alternating when rounds are move than 4 to get correct ordering
                    roundIndex: regionRounds - 1,
                    winningRank: null,
                    finalScore: null
                } 

                // Pushes the match to the reordered matches array and increments counters
                reorderedMatches.push(pushItem);
                matchCounter++;
                pairCounter++;
            }


            bracketRowsIn++; // Increments the bracket row from the edge

            // Loops through the number of regions in the bracket
            // For the bottom half of the bracket region
            for (let i = 0; i < regions; i++) {

                // Creates the object to push to the reordered matches array
                const pushItem = {
                    ...matchOrder[pairCounter], // picks next match in the original ranked order
                    matchNumber: matchCounterDown, // match number in the bracket
                    region: (bracketRowsIn % 2 === 0 ? i : regions - 1 - i), // region number, alternating to stop all odds in one region
                    subRegion: 
                      (j % 2 === 0 || regionRounds < 4 ? 
                        subRegionIterations - 1 - j :
                        j
                      ),
                    // Sub-region number, alternating when rounds are move than 4 to get correct ordering
                    // Values are reversed from the top half to get the correct ordering
                    roundIndex: regionRounds - 1,
                    winningRank: null,
                    finalScore: null
                }

                // Pushes the match to the reordered matches array and decrements counters
                reorderedMatches.push(pushItem);
                matchCounterDown--;
                pairCounter++;
            }
          }

        bracketRowsIn++; // Increments the bracket row from the edge
    }

    // Sorts the matches by match number and sub-region
    reorderedMatches
        .sort((a, b) => a.matchNumber - b.matchNumber)
        .sort((a, b) => a.subRegion - b.subRegion)

    return reorderedMatches;
}